import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import CustomValidators from '../../../shared/custom-validators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerUserFormComponent } from '../customer-user-form/customer-user-form.component';

@Component({
  selector: 'app-components-sales-customer-users-form',
  templateUrl: './customer-users-form.component.html'
})
export class CustomerUsersFormComponent implements OnInit {
  @Input() primaryContactForm: FormGroup;
  @Input() secondaryContactForms: FormArray;
  @Output() secondaryContactFormsChanged = new EventEmitter<FormArray>();
  @Input() countryAbbreviation: string;
  @Input() allowTextMessages = false;

  contactForms: FormGroup[] = [];

  constructor(private fb: FormBuilder,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.setContactTypes();
  }

  addContact(): void {
    const newContact = this.createContactFormGroup();
    const modalRef = this.modalService.open(CustomerUserFormComponent, { size: 'lg' });

    modalRef.componentInstance.contactForm = newContact;
    modalRef.componentInstance.allowTextMessages = this.allowTextMessages;
    modalRef.componentInstance.isNew = true;

    modalRef.result.then(() => {
      this.secondaryContactForms.push(newContact);
      this.setContactTypes();
    });
  }

  editContact(contact: FormGroup): void {
    // Open the Modal
    // Modal dismissed: reset information
    // Modal closed: add to list if not in list, refresh list
    const copy = this.copyContactFormGroup(contact);
    const modalRef = this.modalService.open(CustomerUserFormComponent, { size: 'lg' });

    modalRef.componentInstance.contactForm = copy;
    modalRef.componentInstance.allowTextMessages = this.allowTextMessages;
    modalRef.componentInstance.isNew = false;

    modalRef.result.then(() => {
      contact.get('firstName').setValue(copy.get('firstName').value);
      contact.get('lastName').setValue(copy.get('lastName').value);
      contact.get('email').setValue(copy.get('email').value);
      contact.get('emailRecipientType').setValue(copy.get('emailRecipientType').value);
      contact.get('phone').setValue(copy.get('phone').value);
      contact.get('canReceiveTextMessages').setValue(copy.get('canReceiveTextMessages').value);
      this.setContactTypes();
    });
  }
  
  deleteContact(contact: FormGroup): void {
    const index = this.secondaryContactForms.controls.indexOf(contact);

    if (index > -1) {
      this.secondaryContactForms.removeAt(index);
      this.setContactTypes();
    }
  }

  private createContactFormGroup(): FormGroup {
    return this.fb.group({
      isPrimary: [false, Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, CustomValidators.email, CustomValidators.stringsNotAllowedMethod(() => 
        [this.primaryContactForm.get('email').value], true, 'The primary contact email cannot be used here.')]],
      phone: ['', [CustomValidators.phoneNumberValidator(() => this.countryAbbreviation)]],
      canContact: [true, Validators.required],
      canReceiveTextMessages: [false, Validators.required],
      emailRecipientType: this.fb.control<Boo.Objects.Enums.EmailRecipientTypes>(null)
    });
  }

  private copyContactFormGroup(contact: FormGroup): FormGroup {
    const copy = this.createContactFormGroup();
    copy.get('firstName').setValue(contact.get('firstName').value);
    copy.get('lastName').setValue(contact.get('lastName').value);
    copy.get('email').setValue(contact.get('email').value);
    copy.get('emailRecipientType').setValue(contact.get('emailRecipientType').value);
    copy.get('phone').setValue(contact.get('phone').value);
    copy.get('canReceiveTextMessages').setValue(contact.get('canReceiveTextMessages').value);
    return copy;
  }

  private setContactTypes(): void {
    this.contactForms = [
      this.primaryContactForm,
      ...this.secondaryContactForms.controls.filter(c => c.get('canContact').value)
        .map(c => c as FormGroup)
    ];

    this.secondaryContactForms.markAsTouched();
  }
}
